<template>
  <FormKit
      :type="props.type"
      :name="props.name"
      :label="props.label"
      :validation="props.validation"
      :input-class="props.type === 'select' ? 'form-select' : props.type === 'checkbox' ? 'form-check-input' : 'form-control'"
      :wrapper-class="props.type === 'checkbox' ? 'form-switch' : ''"
      outer-class="form-group my-2"
      :validation-visibility="props.validationVisibility"
      :validation-message="props.validationMessage"
      message-class="text-danger"
      :options="props.type === 'select' ? props.options : undefined"
      :disabled="props.disabled"
      :step="props.step"
      :value="props.value"
  />
</template>

<script setup>
import { defineProps} from 'vue'
const props = defineProps({
  type: String,
  name: String,
  label: String,
  validation: String,
  validationVisibility: {
    type: String,
    default: 'live'},
  validationMessage: Object,
  disabled: {
    type: Boolean,
    default: false
  },
  step: String,
  value: null,
  options: Array,
})

</script>


<style scoped>

</style>

